import { useController, useFormContext } from "react-hook-form";
import { registerLocale } from "react-datepicker";
import { InputLabel, InputLabelProps } from "../InputLabel/InputLabel";
import { InputErrorMessage } from "../InputErrorMessage/InputErrorMessage";
import "./custom-datepicker.css";
import pl from "date-fns/locale/pl";
import { BaseDatepicker } from "./BaseDatepicker";

//@ts-ignore - registerLocale is not typed
registerLocale("pl", pl);

interface PaziaDateSelectProps
  extends Omit<DateSelectProps, "value" | "onChange">,
    // omit two props from DateSelectProps
    InputLabelProps {
  className?: string;
  onChange?: (date: Date | null) => void;
}
export const PaziaDateSelect = ({
  name,
  className = "",
  onChange,
  ...rest
}: PaziaDateSelectProps) => {
  const { control } = useFormContext();
  const { field } = useController({ name, control });

  const onChangeHandler = (date: Date | null) => {
    field.onChange(date);
    if (onChange) onChange(date);
  };

  return (
    <div className={className}>
      <DateSelect
        name={name}
        {...rest}
        value={field.value ?? null}
        onChange={onChangeHandler}
      />
      <InputErrorMessage name={name} />
    </div>
  );
};

interface DateSelectProps extends InputLabelProps {
  defaultValue?: Date;
  disabled?: boolean;
  openToDate?: Date;
  onChange: (date: Date | null) => void;
  value: Date | null;
  range?: [Date, Date];
}

export const DateSelect = ({
  label,
  required,
  name,
  value: propsValue,
  onChange,
  range,
}: DateSelectProps) => {
  return (
    <div className="w-full">
      <InputLabel label={label} required={required} name={name} />

      <BaseDatepicker
        selected={propsValue}
        range={range}
        onChange={(date) => {
          date?.setHours(12);
          onChange(date);
        }}
      />
    </div>
  );
};
